import dynamic from "next/dynamic";

export const JobCard = dynamic(() => import("./component"));
